import { useCallback } from 'react';

export const useCustomMetrics = () => {
    const trackDeviceOnline = useCallback((deviceCount: number) => {
        console.log('Device online count:', deviceCount);
    }, []);

    const trackDeviceOffline = useCallback((deviceCount: number) => {
        console.log('Device offline count:', deviceCount);
    }, []);

    const trackServerStats = useCallback((stats: {
        cpu_usage: number;
        ram_usage: number;
        hdd_usage: number;
        net_download: number;
        net_upload: number;
        storage_usage: number;
    }) => {
        console.log('Server stats:', stats);
    }, []);

    const trackPageLoad = useCallback((pageName: string, loadTime: number) => {
        console.log('Page load:', pageName, loadTime);
    }, []);

    const trackUserAction = useCallback((action: string) => {
        console.log('User action:', action);
    }, []);

    const trackError = useCallback((errorType: string, errorMessage: string) => {
        console.log('Error:', errorType, errorMessage);
    }, []);

    return {
        trackDeviceOnline,
        trackDeviceOffline,
        trackServerStats,
        trackPageLoad,
        trackUserAction,
        trackError
    };
}; 